var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-wall"},[_c('div',{ref:"wrapper",staticClass:"tag-cloud"},_vm._l((_vm.list),function(item,index){return _c('p',{key:index,ref:"tag",refInFor:true,on:{"click":function($event){return _vm.clickTag(item)},"dblclick":function($event){return _vm.dbclickTag(item)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }